// extracted by mini-css-extract-plugin
export default {"wrapper":"adminLogs_wrapper__dEDBe","number":"adminLogs_number__m2uRG","log":"adminLogs_log__rvvEM","logLine":"adminLogs_logLine__1yYfp","important":"adminLogs_important__n43GA"};